/**
 * Polling visibilidade-aware (Task #75 — paridade Sync D-103/#219).
 *
 * Substitui o `window.setInterval(load, ms)` cru dos hooks de dados:
 *   - tick periódico SKIPA quando `document.hidden` (aba em background /
 *     janela minimizada / tela apagada) — zero requests com ninguém olhando;
 *   - aba volta a ficar visível → 1 `load()` imediato (não espera o
 *     próximo tick);
 *   - janela recupera o focus (alt-tab sem troca de aba) → `load()`
 *     também — o cache module-level com TTL dos hooks dedupa, então isso
 *     NÃO vira request extra se o dado ainda está fresco.
 *
 * Função pura (não é hook) DE PROPÓSITO: é chamada DENTRO do useEffect
 * dos hooks existentes, sem mexer na ordem de hooks (lint
 * react-hooks/rules-of-hooks — incidente #85 do Sync).
 *
 * Contexto da paridade: a aba 24h da operação do Sync polava ~315×/dia
 * por hook com ninguém olhando; o sweep #75 achou o MESMO padrão em 19
 * hooks do Cortex.
 */

export function startVisiblePolling(
  load: () => void,
  intervalMs: number,
): () => void {
  const tick = () => {
    if (!document.hidden) load();
  };
  const onVisibilityChange = () => {
    if (!document.hidden) load();
  };
  const id = window.setInterval(tick, intervalMs);
  document.addEventListener("visibilitychange", onVisibilityChange);
  window.addEventListener("focus", onVisibilityChange);
  return () => {
    window.clearInterval(id);
    document.removeEventListener("visibilitychange", onVisibilityChange);
    window.removeEventListener("focus", onVisibilityChange);
  };
}
